import { concat } from 'lodash-es';

import { NavBarItem } from '@core/config';

const getAllNavBarItemChildren = (item: NavBarItem): NavBarItem[] => {
  let items = [];

  if (item.children && item.children.length > 0) {
    items = [...item.children];

    items.map((localItem) =>
      items.push(...getAllNavBarItemChildren(localItem))
    );
  }

  return items;
};

export const flatNavBarItems = (items: Readonly<NavBarItem[]>): NavBarItem[] =>
  concat(items, ...items.map((item) => getAllNavBarItemChildren(item)));
